import { create } from 'zustand';

export const useTemplateVariableStore = create<Record<string, string> | undefined>(() => ({}));
